import { StrictMode } from 'react'
import './style.css'
import { createRoot } from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import App from './App.jsx'
import CanvasCamera from './Components/Background/CanvasCamera.jsx'
import { Preload } from '@react-three/drei'
import { Leva } from 'leva'

const root = createRoot(document.querySelector('#root'))

root.render(
    <StrictMode>
        <div className='pointer-events-none z-10 bg-transparent min-h-svh min-w-svw flex items-center justify-center'>
            <App />
        </div>
        <Canvas
            resize={{ scroll: false }}
            camera={{
                fov: 100,
                near: 0.1,
                far: 1000,
                position: [0, 0, 999],
            }}
            style={{ position: 'fixed', top: 0, left: 0, zIndex: 0 }}
        >
            <Preload all />
            <CanvasCamera />
            <Experience />
        </Canvas>
        <Leva collapsed hidden />
    </StrictMode>
)
